import styled, { css } from 'styled-components';
import { Button, Layout } from 'antd';
import { Link } from 'react-router-dom';
import { media } from '@app/styles/themes/constants';
import { LAYOUT } from '@app/styles/themes/constants';
import { SynergyLogoVariant } from '@app/assets/branding/synergyBrand';

export const Sider = styled(Layout.Sider)`
  position: fixed;
  overflow: visible;
  right: 0;
  z-index: 5;
  min-height: 100vh;
  max-height: 100vh;

  color: var(--text-secondary-color);
  background: var(--layout-sider-bg-color) !important;
  border-inline-end: 1px solid var(--border-color);
  box-shadow: 0 0 1.5rem var(--shadow-color);

  @media only screen and ${media.md} {
    right: unset;
    left: 0;
  }

  @media only screen and ${media.xl} {
    position: unset;
  }
`;

export const CollapseButton = styled(Button)<{ $isCollapsed: boolean }>`
  background: var(--collapse-background-color);

  border: 1px solid var(--border-color);
  transition: all 0.2s ease;
  position: absolute;
  right: 0.5rem;

  ${(props) =>
    props.$isCollapsed &&
    css`
      right: -1rem;
    `}

  color: var(--text-secondary-color);

  &:hover {
    color: var(--text-secondary-color);
    background: var(--primary-color);
    border: 1px solid var(--border-color);
  }

  &:focus {
    color: var(--text-secondary-color);
    background: var(--primary-color);
    border: 1px solid var(--border-color);
  }
`;

export const SiderContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - ${LAYOUT.mobile.headerHeight});

  @media only screen and ${media.md} {
    max-height: calc(100vh - ${LAYOUT.desktop.headerHeight});
  }
`;

export const SiderLogoLink = styled(Link)`
  display: flex;
  align-items: center;
  max-width: calc(100% - 1rem);
  overflow: hidden;
  position: relative;
  border-radius: 0.375rem;

  &:focus-visible {
    outline: 2px solid var(--primary-text-color);
    outline-offset: 0.1875rem;
  }
`;

export const SiderLogoDiv = styled.div`
  height: ${LAYOUT.mobile.headerHeight};
  padding: ${LAYOUT.mobile.headerPadding};
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and ${media.md} {
    height: ${LAYOUT.desktop.headerHeight};
    padding-top: ${LAYOUT.desktop.paddingVertical};
    padding-bottom: ${LAYOUT.desktop.paddingVertical};
  }
`;

export const BrandLogoSurface = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.125rem;
`;

export const BrandLogoViewport = styled.span<{ $standalone: boolean }>`
  position: relative;
  display: block;
  width: ${({ $standalone }) => ($standalone ? '2rem' : '9rem')};
  height: ${({ $standalone }) => ($standalone ? '2rem' : '2.125rem')};
  overflow: hidden;

  @media only screen and ${media.md} {
    width: ${({ $standalone }) => ($standalone ? '2.75rem' : '12.25rem')};
    height: ${({ $standalone }) => ($standalone ? '2.75rem' : '2.875rem')};
  }
`;

const logoScale: Record<SynergyLogoVariant, number> = {
  main: 1.25,
  monochrome: 1.15,
  reverse: 1.14,
  standalone: 1.45,
};

export const BrandLogoImage = styled.img<{
  $variant: SynergyLogoVariant;
}>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: scale(${({ $variant }) => logoScale[$variant]});
`;
